<script setup>
import enUS from '@arco-design/web-vue/es/locale/lang/en-us';
import zhCN from '@arco-design/web-vue/es/locale/lang/zh-cn';
import { computed } from 'vue';
import { RouterView } from 'vue-router';

import noDataSvg from '@/assets/images/no-data-150.svg';
import useLocale from '@/hooks/locale';
import { provideCellEditManager } from '@/hooks/useCellEditManager';
// import anImg from './assets/json/animataion/loading.json';
// import an002 from   './assets/json/animataion/002.json';
// import an003 from   './assets/json/animataion/003.json';

const { currentLocale } = useLocale();

const locale = computed(() => {
  switch (currentLocale.value) {
    case 'zh-CN':
      return zhCN;
    case 'en-US':
      return enUS;
    default:
      return zhCN;
  }
});
provideCellEditManager();
</script>

<template>
  <jw-config-provider size="medium" :locale="locale">
    <template #empty>
      <jw-empty :img-src="noDataSvg" :description="$t('暂无数据')" />
    </template>
    <template #loading>
      <jw-spin>
        <template #icon>
          <!-- <img :src="img" width="16" height="16" alt="烽火" /> -->
          <!-- <vue3-lottie :animationData="anImg" :width="128" /> -->
          <fh-loading />
        </template>
      </jw-spin>
    </template>
    <router-view />
  </jw-config-provider>
</template>

<style scoped lang="less"></style>
